import React from 'react';

const AddToCalendarComponent = ({ title, startDate, endDate, location, description }) => {
    const formatDate = (date) => {
        return new Date(date).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    };

    const generateGoogleCalendarUrl = () => {
        const start = formatDate(startDate);
        const end = formatDate(endDate);
        const text = encodeURIComponent(title);
        const details = encodeURIComponent(description || '');
        const loc = encodeURIComponent(location || '');
        
        return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${start}/${end}&details=${details}&location=${loc}`;
    };

    const generateOutlookUrl = () => {
        const start = new Date(startDate).toISOString();
        const end = new Date(endDate).toISOString();
        const subject = encodeURIComponent(title);
        const body = encodeURIComponent(description || '');
        const loc = encodeURIComponent(location || '');
        
        return `https://outlook.live.com/calendar/0/deeplink/compose?subject=${subject}&startdt=${start}&enddt=${end}&body=${body}&location=${loc}`;
    };

    return (
        <div className="add-to-calendar">
            <h6 className="mb-3">Add to Calendar:</h6>
            <div className="d-flex gap-2">
                <a 
                    href={generateGoogleCalendarUrl()}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm"
                    title="Add to Google Calendar"
                >
                    <i className="bi bi-google me-1"></i>
                    Google
                </a>
                <a 
                    href={generateOutlookUrl()}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm"
                    title="Add to Outlook"
                >
                    <i className="bi bi-microsoft me-1"></i>
                    Outlook
                </a>
            </div>
        </div>
    );
};

export default AddToCalendarComponent;
